import { WebMercatorViewport } from "@deck.gl/core"
import { createPolygonKML } from "@nova/data-create-polygon-kml"
import { createSVGFromKML } from "@nova/data-create-svg-from-kml"
import { FC, useMemo } from "react"
import { BORDER_THICKNESS } from "../PDFSnapshotContainer"
import { convertPerimeterPolygonsToNumberArray } from "features/entity-caching/fire-perimeters/module"
import { Polygon } from "@nova/protobuf"
import { useViewport } from "features/map/GlobalViewState"

type InsetComponentProps = {
    offsetX: number
    offsetY: number
    width: number
    height: number
    polygons?: Polygon[]
}

export const InsetComponent: FC<InsetComponentProps> = ({
    offsetX,
    offsetY,
    polygons,
    width,
    height,
}) => {
    const view = useViewport()
    const perimeterSvg = useMemo(() => {
        if (!polygons?.length) return null
        const topLeft = new WebMercatorViewport(view).unproject([
            offsetX + BORDER_THICKNESS,
            offsetY + BORDER_THICKNESS,
        ])
        const topRight = new WebMercatorViewport(view).unproject([
            offsetX + width - BORDER_THICKNESS,
            offsetY + BORDER_THICKNESS,
        ])
        const bottomRight = new WebMercatorViewport(view).unproject([
            offsetX + width - BORDER_THICKNESS,
            offsetY + height - BORDER_THICKNESS,
        ])
        const bottomLeft = new WebMercatorViewport(view).unproject([
            offsetX + BORDER_THICKNESS,
            offsetY + height - BORDER_THICKNESS,
        ])
        const svgData = btoa(
            createSVGFromKML(
                [
                    `<?xml version="1.0" encoding="UTF-8"?>
                              <kml xmlns="http://www.opengis.net/kml/2.2">
                                <Document>
                                  <name></name>
                                  <Style id="color">
                                    <LineStyle>
                                      <color>FFFF0000</color>
                                      <width>2</width>
                                    </LineStyle>
                                    <PolyStyle>
                              	<fill>0</fill>
                                    </PolyStyle>
                                  </Style>
                                  <Placemark>
                                    <name></name>
                                    <styleUrl>#color</styleUrl>
                                    <Polygon>
                                      <tessellate>1</tessellate>
                                      <outerBoundaryIs>
                                          <LinearRing>
                                              <coordinates>
                                              ${topLeft[0]},${topLeft[1]},0
                                              ${topRight[0]},${topRight[1]},0
                                              ${bottomRight[0]},${bottomRight[1]},0
                                              ${bottomLeft[0]},${bottomLeft[1]},0
                                              ${topLeft[0]},${topLeft[1]},0
                                              </coordinates>
                                          </LinearRing>
                                      </outerBoundaryIs>
                                  </Polygon>
                                  </Placemark>
                                </Document>
                              </kml>`,
                    createPolygonKML("", convertPerimeterPolygonsToNumberArray(polygons)),
                ],
                100,
                100,
                1,
                1,
                ["#0E78FF", "red"]
            )
        )
        return (
            <img
                src={`data:image/svg+xml;base64,${svgData}`}
                alt="svg"
                className="h-full w-full"
                style={{ transform: `rotate(${-view.bearing}deg)` }}
            />
        )
    }, [polygons, view, offsetX, offsetY, width, height])

    return <div className="bg-white dark:bg-black-900 h-full w-full">{perimeterSvg}</div>
}
